import { useState } from "react";
import api from "../lib/api";
import { apiError } from "../lib/auth";
import { useFlash } from "../lib/flash";

export default function BulkReminderBar({ ids, onDone, onCancel }) {
  const flash = useFlash();
  const [busy, setBusy] = useState(false);
  const run = async (on) => {
    setBusy(true);
    try {
      const r = await api.post("/offers-bulk/comment-reminder", { ids: [...ids], on });
      flash(r.data.flash);
      onDone();
    } catch (err) {
      flash(apiError(err.response?.data?.detail) || err.message, "error");
    } finally {
      setBusy(false);
    }
  };
  const none = !ids.size || busy;
  return (
    <div className="bulk-bar" data-testid="bulk-reminder-bar">
      <b data-testid="bulk-selected-count">{ids.size} valgt</b>
      <button type="button" className="btn small" disabled={none} onClick={() => run(false)} data-testid="bulk-reminder-off">
        Slå påmindelse fra
      </button>
      <button type="button" className="btn small" disabled={none} onClick={() => run(true)} data-testid="bulk-reminder-on">
        Slå påmindelse til
      </button>
      <button type="button" className="btn small ghost" onClick={onCancel} data-testid="bulk-cancel">
        Annuller
      </button>
    </div>
  );
}
